import { graphql } from "gatsby";
import React, { DetailedHTMLProps, FC, HTMLAttributes } from "react";

import { PillProps } from "../../forms";
import { BrandCard } from "./variants/brand-card";
import { DefaultCard } from "./variants/default-card";

export interface ImageCardProps
  extends Queries.ImageCardDataFragment,
    Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "className"> {
  keepOriginalAspectRatio?: boolean;
  showBody?: boolean;
  /**
   * Only used in the non-brand variants.
   * Brand variant ignores the property even if set.
   */
  tags?: Pick<PillProps, "color" | "children">[];
  textAlign?: "center" | "left";
}

export const ImageCard: FC<ImageCardProps> = ({ variant, tags, ...props }) => {
  // Deprecated variant, enum value is not present anymore.
  // TODO: remove once there are no more entries on Contentful
  // (they still may need to see them rendered, now)
  if (variant === "brand") return <BrandCard {...props} />;

  return <DefaultCard variant={variant} tags={tags} {...props} />;
};

export const query = graphql`
  fragment ImageCardData on ContentfulImageCard {
    __typename
    variant
    title
    description {
      raw
    }
    image {
      gatsbyImageData
    }
    logo {
      gatsbyImageData
    }
    ctas {
      ...CtaData
    }
  }
`;
